export default __webpack_public_path__ + "static/media/profile_img.fe7fdf8b.jpg";